import {getDataFormattata} from "../../../../../../utility/common";
import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import NsDataTable from "../../../../../../components/tabelle/NsDataTable";

export default function TabellaQuoteCertificatoView({
                                                        certificato,
                                                        quote,
                                                    }) {

    return (
        <NsDataTable
            data={quote}
            columns={[
                {
                    name: 'Data',
                    selector: row => getDataFormattata(row.data_pagamento),
                    sortable: true,
                },
                {
                    name: 'Oggetto',
                    selector: row => row.tipo_versamento,
                    sortable: true,
                },
                {
                    name: 'Importo €',
                    selector: row => row.importo,
                    sortable: true,
                },
                {
                    name: 'Modalità di pagamento',
                    selector: row => row.modalita,
                    sortable: true,
                },
                {
                    name: '',
                    selector: row => <Fragment>
                        <Link to={`/upd-quota-cert/${row.id_certificato}/${row.id_quota}`}
                              className="btn btn-dark rfi-btn-table"
                              data-toggle="tooltip" title="Modifica">
                            <i className="fas fa-pen"/> <span
                            className={'rfi-display-mobile'}>Modifica</span>
                        </Link>
                    </Fragment>,
                    sortable: false,
                    right: true,
                    visible: () => certificato && (!certificato.id_doc_firmato || certificato.id_doc_firmato == '')
                }
            ]}
            addPagination={false}
            addFiltri={false}
        />
    );
}